var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentWithImage',{attrs:{"src":"page503","image-order":"1","image-order-sm":"1","margin":"50px 0"}},[_c('text-container',[_c('h2',{staticClass:"h1",domProps:{"innerHTML":_vm._s(_vm.$t("page503.title"))}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t("page503.text"))}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d200fd1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/Page503.vue
// module id = null
// module chunks = 